import React from "react"
import { Link } from "gatsby"
import logo from "../images/LogoColorNoText_small.png"

class MainNav extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      menuVisible: false,
      displayMenu: false,
    }

    this.showDropdownMenu = this.showDropdownMenu.bind(this)
    this.hideDropdownMenu = this.hideDropdownMenu.bind(this)
    this.handleMenuToggle = this.handleMenuToggle.bind(this)
  }

  showDropdownMenu(event) {
    event.preventDefault()
    this.setState({ displayMenu: true }, () => {
      document.addEventListener("click", this.hideDropdownMenu)
    })
  }

  hideDropdownMenu() {
    this.setState({ displayMenu: false }, () => {
      document.removeEventListener("click", this.hideDropdownMenu)
    })
  }

  handleMenuToggle = e => {
    e.preventDefault()
    this.setState(state => {
      return { menuVisible: !state.menuVisible }
    })
  }

  render() {
    const { title, isHome } = this.props
    return (
      <React.Fragment>
        <header id="header" className={isHome ? "alt" : null}>
          <h1>
            <img src={logo} alt={title + " Logo"} title={title + " Logo"} />
            <Link to="">{title}</Link>
          </h1>
          <nav id="nav">
            <ul>
              <li>
                <Link to="">Home</Link>
              </li>
              <li class="submenu">
                <a href="#" class="submenu" onClick={this.showDropdownMenu}>
                  Previous Projects
                </a>
                {this.state.displayMenu ? (
                  <ul className="dropotron level-0 right">
                    <li>
                      <Link to="portfolio\external">External</Link>
                    </li>
                    <li>
                      <Link to="portfolio\internal">Internal</Link>
                    </li>
                  </ul>
                ) : (
                  <></>
                )}
              </li>
              <li>
                <Link to="services">Services</Link>
              </li>
              <li>
                <Link to="contact">Contact</Link>
              </li>
              <li>
                <Link to="about">About</Link>
              </li>
            </ul>
          </nav>
          <a
            href="#navPanel"
            class="navPanelToggle"
            onClick={this.handleMenuToggle}
          ></a>
        </header>
        {this.state.menuVisible ? (
          <div id="navPanel" className="visible">
            <nav>
              <Link
                className="link depth-0"
                to=""
                style={{ "-webkit-tap-highlight-color": "rgba(0, 0, 0, 0)" }}
              >
                <span className="indent-0"></span>Home
              </Link>
              <a href="#" class="link depth-0">
                Previous Projects
              </a>
              <Link
                className="link depth-1"
                to="portfolio/external"
                style={{ "-webkit-tap-highlight-color": "rgba(0, 0, 0, 0)" }}
              >
                <span className="indent-1"></span>External
              </Link>
              <Link
                className="link depth-1"
                to="portfolio/internal"
                style={{ "-webkit-tap-highlight-color": "rgba(0, 0, 0, 0)" }}
              >
                <span className="indent-1"></span>Internal
              </Link>
              <Link
                className="link depth-0"
                to="services"
                style={{ "-webkit-tap-highlight-color": "rgba(0, 0, 0, 0)" }}
              >
                <span className="indent-0"></span>Services
              </Link>
              <Link
                className="link depth-0"
                to="contact"
                style={{ "-webkit-tap-highlight-color": "rgba(0, 0, 0, 0)" }}
              >
                <span className="indent-0"></span>Contact
              </Link>
              <Link
                className="link depth-0"
                to="about"
                style={{ "-webkit-tap-highlight-color": "rgba(0, 0, 0, 0)" }}
              >
                <span className="indent-0"></span>About
              </Link>
            </nav>
            <a
              href="#navPanel"
              onClick={this.handleMenuToggle}
              className="close"
              style={{ "-webkit-tap-highlight-color": "rgba(0, 0, 0, 0)" }}
            ></a>
          </div>
        ) : (
          <></>
        )}
      </React.Fragment>
    )
  }
}

export default MainNav
